/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    ContentBlock,
    FlexCol,
    FlexRow,
    Inline,
    Placeholder,
    PlaceholderText,
    Stack,
} from 'sarsaparilla';
import FindACampsiteSectionListPlaceholder from '../../../../features/facilityPageV3/components/FindACampsite/placeholders/FindACampsiteSectionListPlaceholder';
import CampgroundPageV3HeaderPlaceholder from '../../../../features/facilityPageV3/components/Header/placeholders/CampgroundPageV3HeaderPlaceholder';
import HeroGalleryPlaceholder from '../../../../features/facilityPageV3/components/HeroGallery/placeholders/HeroGalleryPlaceholder';
import './CampgroundPageLoading.scss';

const TAB_COUNT = 5;

/** Full-page desktop skeleton shown while the campground page chunk/data loads. */
export default function CampgroundPageLoading() {
    return (
        <div className="rec-campground-page campground-page-loading" aria-hidden="true">
            <div className="campground-page-loading-hero">
                <HeroGalleryPlaceholder />
            </div>
            <ContentBlock>
                <Stack space="lg" className="mt-5">
                    <Inline space="sm" className="campground-page-loading-tags">
                        <Placeholder height="24px" width="132px" borderRadius="999px" />
                        <Placeholder height="24px" width="104px" borderRadius="999px" />
                    </Inline>
                    <CampgroundPageV3HeaderPlaceholder />
                    <FlexRow>
                        <FlexCol md={12} lg={7}>
                            <PlaceholderText fontSize={19} lineHeight={26} lines={3} />
                        </FlexCol>
                    </FlexRow>
                    <div className="campground-page-loading-tabs">
                        {Array.from({ length: TAB_COUNT }).map((_, index) => (
                            <div
                                key={`campground-page-loading-tab-${index}`}
                                className="campground-page-loading-tab"
                            >
                                <Placeholder height="20px" width="100%" />
                            </div>
                        ))}
                    </div>
                    <FindACampsiteSectionListPlaceholder />
                </Stack>
            </ContentBlock>
        </div>
    );
}
